import type { ILeagueItem } from '../types/myLeagues';
import LeagueCard from './LeagueCard';

interface LeagueListProps {
  leagues: ILeagueItem[];
  onLeagueSelect: (league: ILeagueItem) => void;
  onEditLeague?: (league: ILeagueItem) => void;
  showRoleBadge?: boolean;
}

function LeagueList({ leagues, onLeagueSelect, onEditLeague, showRoleBadge = true }: LeagueListProps) {
  return (
    <div className="myleagues-list">
      {leagues.map((league) => (
        <LeagueCard
          key={league.leagueId}
          league={league}
          onClick={() => onLeagueSelect(league)}
          onEditLeague={onEditLeague}
          showRoleBadge={showRoleBadge}
        />
      ))}
    </div>
  );
}

export default LeagueList;
